import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/opt/build/repo/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["Experience"] */ "/opt/build/repo/src/app/components/Development/Experience.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Projects"] */ "/opt/build/repo/src/app/components/Development/Projects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SideProjects"] */ "/opt/build/repo/src/app/components/Development/SideProjects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageIntro"] */ "/opt/build/repo/src/app/components/PageIntro.tsx");
